export default {"src":"/_next/static/media/icon-buyer-guide.43967410.svg","height":78,"width":71,"blurWidth":0,"blurHeight":0};